import SimpleArrow from '@components/bits/icons/SimpleArrow';
import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';
type Props = {
  startIndex;
  endIndex;
  itemTotal;
  setPageIndex;
};

const ToolsPagination: FunctionComponent<Props> = ({
  startIndex = 0,
  endIndex = 0,
  itemTotal = 0,
  setPageIndex,
}) => {
  return (
    <div className={`${styles.root}`}>
      <span className={styles['_button']} onClick={() => setPageIndex(-1)}>
        <SimpleArrow direction={'left'} />
      </span>
      <span>{`viser ${startIndex + 1}—${endIndex} av ${itemTotal}`}</span>
      <span className={styles['_button']} onClick={() => setPageIndex(1)}>
        <SimpleArrow direction={'right'} />
      </span>
    </div>
  );
};

export default React.memo(ToolsPagination);
